export const DEBUG_LAYOUT = false;

export const debugBorderAqua = { border: '1px solid aqua' };
export const debugBorderRed = { border: '1px solid red' };
export const debugBorderGreen = { border: '1px solid green' };
export const debugBorderWhite = { border: '1px solid white' };
export const debugBorderOrange = { border: '1px solid orange' };
